<template>
  <div class="statueModel">
    <div class="row-item element-list" v-if="statusModal.type == 'status'">
      <div class="left-item jb-bg">在库状态：</div>
      <div class="rigth-item">
        <el-select
          style="width: 100%"
          v-model="statusModal.status"
          size="small"
          placeholder="请选择">
          <el-option
            v-for="item in zkOptions"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="row-item element-list" v-else>
      <div class="left-item jb-bg">状态：</div>
      <div class="rigth-item">
        <el-select
          style="width: 100%"
          v-model="form.states"
          size="small"
          @change ="changeState"
          placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </div>
      <template v-if="form.states==2||form.states==6">
        <div class="left-item jb-bg">停用时间：</div>
      <el-date-picker
       value-format="yyyy-MM-dd HH:mm:ss"
      v-model="form.stopTime"
      type="datetime"
      placeholder="选择日期时间">
    </el-date-picker>
      <div class="left-item jb-bg"> {{form.states==6?'报废证明：':' 停用缘由：'}}</div>
      <el-input
  type="textarea"
  :rows="2"
  placeholder="请输入内容"
  v-model="form.stopReason">
</el-input>
      </template>
    </div>
    <div class="footer">
      <el-button size="mini" @click="cancel">取消</el-button>
      <el-button size="mini" type="primary" @click="ok">确认</el-button>
    </div>
  </div>
</template>

<script>
  import constants from "@/assets/data/common";
import { watch } from "less";
  export default {
    name: "statueModel",
    props:{
      statusModal:Object
    },
    data(){
      return{
        form:{
          states:null,
          stopTime:null,
          stopReason:null,
        },
        options:constants.options,//状态
        zkOptions:constants.zkOptions,//在库状态
      }
    },
    watch:{
      statusModal:{
    handler(newVal){
      console.log(newVal,'newVal')
      this.form = {...newVal}
    },
    deep:true,
    immediate:true
  }
    },
    methods:{
      changeState(){
      this.form.stopTime = null,
      this.form.stopReason = null
      },
      cancel(){
        this.$emit("statusCancel", {})
      },
      ok(){
        this.$emit("statusOk",this.form)
      }
    }
  }
</script>

<style lang="less" scoped>
  .statueModel{
    .element-list{
      display: grid;//网格形式
      grid-template-columns:  25% 65%;//这里表明分为3列
      grid-gap: 10px;//每列的间隔
      .left-item{
        line-height: 32px;
        text-align: right;
      }
    }
    .footer {
      margin-top: 20%;
      clear: both;
      width: 100%;
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Instrumentmanagemen/components/statueModel.vue